module.exports = __webpack_public_path__ + "assets/img/welcome-down-arrow.svg";